import apiClient from "../utils/apiClient";
import { RecentViewedRequestDto, RoleDto } from "../types/Role";
import {
  GetAllFilesAndFoldersByUserDto,
  GetAllFilesFoldersRequestDto,
  GlobalSearchDto,
  SearchRequestDto,
} from "../types/FolderPermission";

export const getAllRolesByUser = async (userId?: number): Promise<RoleDto[]> => {
  const response = await apiClient.get<RoleDto[]>(`/portal/role/allRoles-by-user/${userId}`);
  return response.data;
};

export const getActiveRoles = async (): Promise<RoleDto[]> => {
  const response = await apiClient.get<RoleDto[]>(`/portal/role/roles-list`);
  return response.data;
};

export const getAllFilesFolderByUser = async (
  requestData?: GetAllFilesFoldersRequestDto
): Promise<GetAllFilesAndFoldersByUserDto[]> => {
  const response = await apiClient.post<GetAllFilesAndFoldersByUserDto[]>(
    "/portal/role/filesFolders-by-userId",
    requestData
  );
  return response.data;
};

export const getAllFilesFolderBySearch = async (
  requestData?: SearchRequestDto
): Promise<GlobalSearchDto[]> => {
  const response = await apiClient.post<GlobalSearchDto[]>(
    "/portal/role/folders-files-list",
    requestData
  );
  return response.data;
};

export const getRecentViewedItems = async (
  requestData?: RecentViewedRequestDto
): Promise<GetAllFilesAndFoldersByUserDto[]> => {
  const response = await apiClient.post<GetAllFilesAndFoldersByUserDto[]>(
    "/portal/role/recent-viewed-items",
    requestData
  );
  return response.data;
};
